import { useState, useEffect } from 'react';
import { authAPI } from '../api/auth';
import { usePairsConfig } from './usePairsConfig';
import { isPairShownInOverview } from '../utils/pairSettings';

export function useUserOverviewPairs() {
  const { overviewPairs, loading: pairsLoading } = usePairsConfig();
  const [userOverviewPairs, setUserOverviewPairs] = useState([]);
  const [settingsLoading, setSettingsLoading] = useState(true);

  useEffect(() => {
    if (pairsLoading) {
      return;
    }
    let cancelled = false;
    (async () => {
      setSettingsLoading(true);
      try {
        const res = await authAPI.getApiKeys();
        const data = res.success && res.data ? res.data : {};
        const filtered = overviewPairs.filter((pair) => isPairShownInOverview(data, pair));
        if (!cancelled) {
          setUserOverviewPairs(filtered);
        }
      } catch {
        if (!cancelled) {
          setUserOverviewPairs(overviewPairs);
        }
      } finally {
        if (!cancelled) {
          setSettingsLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [pairsLoading, overviewPairs]);

  return {
    userOverviewPairs,
    loading: pairsLoading || settingsLoading,
  };
}
